export enum PUBLIC_PAGE_STATUS {
  NOT_OPEN = 'NOT_OPEN',
  STARTED = 'STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  ALMOST_DONE = 'ALMOST_DONE',
  DONE = 'DONE',
}

export default PUBLIC_PAGE_STATUS;